/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["th[_ngcontent-%COMP%]{margin-right:15px}th[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{float:left;cursor:pointer}td[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{padding:4px;margin:8px;border:1px solid #d3d3d3;border-radius:4px;background-color:#f9f9f9}.show_more[_ngcontent-%COMP%]{margin-left:10px;cursor:pointer;font-weight:700}\n/*# sourceMappingURL=bundle-revenue.component.css.map*/"];
export { styles as styles };
